import { render, staticRenderFns } from "./mercadopago.vue?vue&type=template&id=12223b7a&"
import script from "./mercadopago.vue?vue&type=script&lang=js&"
export * from "./mercadopago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports